import React from 'react';
import { FadeIn } from './FadeIn';
import { CalendarIcon, ClipboardCheckIcon, BarChartIcon, TrophyIcon } from 'lucide-react';
export function Transformation() {
  const steps = [{
    icon: <CalendarIcon className="w-6 h-6 text-hyrox-dark" data-id="element-230" />,
    title: 'El lunes a la mañana',
    text: 'Arrancás sabiendo exactamente qué vas a trabajar con cada grupo. No porque lo pensaste el domingo a las 11 de la noche buscando en YouTube. Sino porque lo planificaste en 20 minutos con un sistema que ya tiene la lógica de progresión resuelta.'
  }, {
    icon: <ClipboardCheckIcon className="w-6 h-6 text-hyrox-dark" data-id="element-231" />,
    title: 'Al terminar cada sesión',
    text: 'Registrás los datos de tus alumnos en una ficha de 3 minutos. RPE, calidad técnica, progreso de carrera, observaciones. Ese registro acumulado semana a semana se convierte después en el argumento más poderoso que podés tener cuando alguien te pregunta por qué deberían pagarte más.'
  }, {
    icon: <BarChartIcon className="w-6 h-6 text-hyrox-dark" data-id="element-232" />,
    title: 'Al final del bloque',
    text: 'Abrís la ficha de re-test, comparás los datos de entrada con los de hoy y en 10 minutos tenés un informe de progreso real para cada alumno. Se lo mostrás. Lo ve. Lo entiende. Y en ese momento ya no estás "vendiendo" tu servicio. Estás mostrando evidencia.'
  }, {
    icon: <TrophyIcon className="w-6 h-6 text-hyrox-dark" data-id="element-233" />,
    title: 'El día de la carrera',
    text: 'Tu alumno llega con una estrategia de competencia clara, con un mapa de pacing, con una estructura mental para cada estación. No improvisa. No explota en el kilómetro 4. Ejecuta. Y cuando cruza la línea de llegada con su mejor tiempo, ese resultado tiene tu nombre en el sistema que lo construyó.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-hyrox-surface relative overflow-hidden" data-id="element-234">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-hyrox-orange/5 rounded-full blur-[120px] pointer-events-none" data-id="element-235" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-236">
        <FadeIn data-id="element-237">
          <h2 className="text-3xl sm:text-5xl font-display font-bold text-center text-white mb-16 leading-tight" data-id="element-238">
            Existe una versión de tu trabajo como coach
            <br className="hidden sm:block" data-id="element-239" />
            <span className="text-hyrox-orange" data-id="element-240">
              {' '}
              que se ve completamente diferente.
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-241">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-242">
              <div className="flex flex-col sm:flex-row gap-6 items-start bg-hyrox-dark border border-hyrox-muted p-6 sm:p-8 rounded-2xl relative overflow-hidden group hover:border-hyrox-orange/50 transition-colors" data-id="element-243">
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-hyrox-muted group-hover:bg-hyrox-orange transition-colors" data-id="element-244" />
                <div className="bg-hyrox-orange w-12 h-12 rounded-full flex items-center justify-center shrink-0 shadow-[0_0_20px_rgba(255,107,26,0.3)]" data-id="element-245">
                  {step.icon}
                </div>
                <div data-id="element-246">
                  <h3 className="text-xl font-display font-bold text-white mb-2" data-id="element-247">
                    {step.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-248">{step.text}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-249">
          <div className="text-center mt-16" data-id="element-250">
            <p className="text-2xl sm:text-3xl font-display font-bold text-white" data-id="element-251">
              Esa versión de tu trabajo no requiere más horas.{' '}
              <br className="hidden sm:block" data-id="element-252" />
              <span className="text-hyrox-orange" data-id="element-253">
                Requiere el sistema correcto.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}